import { useEffect } from "react";
import { useAuthContext, useBillingCredits, useSubscription } from "@/context/AuthContext";
import { processAiPackPurchase, processSubscriptionCancel, processSubscriptionPurchase } from "@/lib/billingAnalytics";
import { pushSignUpOnce, pushTrialStartOnce } from "@/lib/signupContext";

// Global side-effect component. Must live inside AuthContextProvider.
// Listens to subscription / billingCredits / user changes and fires the
// corresponding GA4 lifecycle events from anywhere in the app -- not just
// /settings/plan -- so that Stripe's success_url can return the user to any
// page and we still capture purchase, ai_pack_purchase, subscription_cancel,
// and trial_start reliably (with per-event localStorage dedupe inside each
// processor).
export default function BillingAnalyticsTracker(): null {
  const {
    user
  } = useAuthContext();
  const {
    subscription
  } = useSubscription();
  const {
    billingCredits
  } = useBillingCredits();
  useEffect(() => {
    if (subscription === undefined) return;
    processSubscriptionPurchase(subscription);
    processSubscriptionCancel(subscription);
  }, [subscription?.id, subscription?.status, subscription?.priceInterval, subscription?.type]);
  useEffect(() => {
    if (billingCredits === undefined) return;
    processAiPackPurchase(billingCredits);
  }, [billingCredits]);
  useEffect(() => {
    if (!user?.uid) return;
    if (user.emailVerified === false) return;
    pushSignUpOnce(user);
    pushTrialStartOnce(user);
  }, [user?.uid, user?.emailVerified]);
  return null;
}